import Axios from 'axios';
import { getServerURL } from 'src/modules/debug/utils';
const axios = Axios.create({
    baseURL: getServerURL(),
});
export default function getAxiosInstance() {
    return axios;
}
